import { Typography } from "antd";
import { useControllers } from "../../Contexts/dashboardHooks";
import type { ControllerKind } from "../../Processing/types";
import { boundController } from "../../Processing/controllerBindings";
import { controllerSummary } from "../../Utils/controllerSummary";
import type { SubjectResolver } from "../../Utils/controllerSummary";

const { Text } = Typography;


/** Short label per kind, matching the controller widget's tab names. */
export const CONTROLLER_KIND_LABELS: Record<ControllerKind, string> = {
  date: "Dates",
  single_date: "Day",
  single_player: "Athlete",
  subject: "Subjects",
};

// Moved to Utils/controllerSummary.ts so component-free callers can read them.
export { controllerSummary, controllerSummaryDetailed } from "../../Utils/controllerSummary";

interface SectionSummaryProps {
  kind: ControllerKind;
  /** The controller this section follows, if any. */
  controllerId?: string;
  /** What to show when the section is NOT bound — the widget's own summary. */
  own: string;
  getSubjectEntities?: SubjectResolver;
}

/**
 * The one-line summary beside an accordion header.
 *
 * A bound section must summarise its CONTROLLER, not its own dormant values — otherwise
 * the header reads "Kevin Lutz" while the panel below it shows the controller's athlete.
 * Bound summaries render in muted blue to match the section they describe.
 */
export function SectionSummary({
  kind,
  controllerId,
  own,
  getSubjectEntities,
}: SectionSummaryProps) {
  const controller = boundController(controllerId, kind, useControllers());
  if (!controller) {
    return <Text type="secondary" style={{ fontSize: 11 }}>{own}</Text>;
  }
  const misc = controller.spec.slicer_builder_misc ?? {};
  return (
    <Text className="awm-bound-summary">
      {controllerSummary(kind, misc, getSubjectEntities, controller.controls)}
    </Text>
  );
}
